import styled from '@emotion/styled';
import * as React from 'react';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const BetStGeorgeLogo = observer(
    'BetStGeorgeLogo',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='196'
            height='48'
            viewBox='0 0 196 48'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <path
                fill='#FF1A1A'
                fillRule='evenodd'
                d='M29.68 25.44c1.9 0 3.57.68 4.46 1.93h.06c-.03-.39-.03-1.07-.03-1.55h5.33V39.9c0 4.91-3.57 8.1-8.75 8.1-4.14 0-6.73-1.73-8-4.44l4.66-1.9c.6 1.2 1.7 1.85 3.24 1.85 2.12 0 3.52-1.25 3.52-3.4 0-.44 0-.74.03-1.19h-.06c-.86 1.4-2.67 2.32-4.9 2.32-4.09 0-6.88-3.18-6.88-7.62 0-4.73 2.97-8.18 7.32-8.18Zm1.3 4.79c-1.96 0-3.3 1.49-3.3 3.51 0 2.03 1.34 3.4 3.3 3.4 1.97 0 3.28-1.34 3.28-3.4 0-2.05-1.3-3.51-3.28-3.51ZM93.56 25.44c1.9 0 3.58.68 4.47 1.93h.06c-.03-.39-.03-1.07-.03-1.55h5.33V39.9c0 4.91-3.58 8.1-8.75 8.1-4.14 0-6.73-1.73-8.01-4.44l4.67-1.9c.6 1.2 1.7 1.85 3.24 1.85 2.11 0 3.52-1.25 3.52-3.4 0-.44 0-.74.03-1.19h-.06c-.86 1.4-2.68 2.32-4.9 2.32-4.09 0-6.89-3.18-6.89-7.62 0-4.73 2.98-8.18 7.32-8.18Zm1.32 4.79c-1.97 0-3.3 1.49-3.3 3.51 0 2.03 1.33 3.4 3.3 3.4 1.97 0 3.27-1.34 3.27-3.4 0-2.05-1.3-3.51-3.27-3.51Z'
                clipRule='evenodd'
            />
            <path
                fill='#FF1A1A'
                d='M19.86 20.15c1 .24 1.3 1.54.37 2.16-.12.08-.28.16-.4.48-.13.32-.37 1.64-.38 1.68a.93.93 0 0 0 .91 1.13h2.73c.12 0 .25.04.35.13v-.01c.16.13.2.36.12.55l-.16.4a.48.48 0 0 1-.45.3h-2.47a.17.17 0 0 0-.17.14l-.53 2.48-1.58 7.46c-.66 4.24-3.1 6.25-3.16 6.26-.31 0-1.66-2.35-.76-6.71l2.01-9.46c.02-.06 0-.1-.02-.12a.14.14 0 0 0-.1-.04h-1.8a.5.5 0 0 1-.46-.3.45.45 0 0 1-.02-.3l.08-.39a.49.49 0 0 1 .47-.38h2.5c.7 0 1.31-.49 1.46-1.17.01-.02.43-1.62.43-1.87s-.14-.49-.22-.62c-.57-.96.25-2 1.25-1.8Z'
            />
            <path
                fill='#FF1A1A'
                fillRule='evenodd'
                d='M49.08 25.27c5.02 0 8.01 3.27 8.01 8.51 0 .6-.03 1.08-.09 1.64H45.72a3.48 3.48 0 0 0 3.54 2.74c1.43 0 2.53-.56 3.1-1.9l4.25 1.88c-1.51 3-4.19 4.4-7.58 4.4-5 0-8.4-3.54-8.4-8.6v-.01c0-5.1 3.43-8.66 8.45-8.66Zm.06 4.37c-1.75 0-2.85.98-3.36 2.47h6.64a3.16 3.16 0 0 0-3.28-2.47ZM112.98 25.27c5.02 0 8 3.27 8 8.51 0 .6-.03 1.08-.09 1.64h-11.28a3.48 3.48 0 0 0 3.54 2.74c1.43 0 2.54-.56 3.1-1.9l4.26 1.88c-1.52 3-4.2 4.4-7.59 4.4-5 0-8.4-3.54-8.4-8.6v-.01c0-5.1 3.43-8.66 8.46-8.66Zm.06 4.37c-1.76 0-2.85.98-3.36 2.47h6.63a3.15 3.15 0 0 0-3.27-2.47ZM66.44 25.27c5.04 0 8.58 3.6 8.58 8.6s-3.58 8.66-8.58 8.66-8.57-3.6-8.57-8.63c0-5.04 3.54-8.63 8.57-8.63Zm0 4.84c-2.02 0-3.3 1.7-3.3 3.78 0 2.1 1.28 3.79 3.3 3.79 2.03 0 3.28-1.73 3.28-3.8v-.02c0-2.05-1.25-3.75-3.28-3.75Z'
                clipRule='evenodd'
            />
            <path
                fill='#FF1A1A'
                d='M6.92 25.26c2.14 0 3.96.83 5.33 2.59l-3.36 3.1c-.63-.9-1.3-1.43-2.17-1.43-.86 0-1.4.44-1.4 1.04 0 .77.8 1.04 1.78 1.28 3.54.72 5.38 2.41 5.38 5.33 0 3.18-2.62 5.35-6.19 5.35a7.39 7.39 0 0 1-6.28-3.1H0l3.3-3c.81 1.07 1.91 1.85 3.14 1.85.95 0 1.45-.45 1.45-1.08 0-.74-.62-.98-1.51-1.21C2.9 35.2.8 33.62.8 30.56c0-3.28 2.75-5.3 6.11-5.3ZM84.87 25.74c.3 0 .57 0 .9.09v4.88h-1.29c-2.05 0-3.03 1.34-3.03 3.52v7.76h-5.3V25.83h5.3v1.94h.06a3.8 3.8 0 0 1 3.36-2.03Z'
            />
            <path
                fill='#FF1A1A'
                fillRule='evenodd'
                d='M28.2 4.94c5.03 0 8.01 3.28 8.01 8.52 0 .6-.03 1.07-.08 1.64H24.84a3.48 3.48 0 0 0 3.54 2.74c1.43 0 2.54-.57 3.1-1.9l4.26 1.87c-1.52 3.01-4.2 4.4-7.59 4.4-5 0-8.4-3.53-8.4-8.6 0-5.1 3.43-8.67 8.46-8.67Zm.07 4.38c-1.76 0-2.85.99-3.36 2.47h6.64a3.16 3.16 0 0 0-3.28-2.47ZM7.05 7.08h.05c1.1-1.37 2.8-2 4.44-2 4.2 0 7.38 3.5 7.38 8.46 0 4.97-3.37 8.48-7.36 8.48a5.36 5.36 0 0 1-4.46-1.96h-.05v1.61h-5.3V0h5.3v7.08Zm3.24 2.8c-1.97 0-3.3 1.52-3.3 3.66 0 2.15 1.36 3.7 3.3 3.7 1.93 0 3.3-1.61 3.3-3.7 0-2.08-1.34-3.66-3.3-3.66Z'
                clipRule='evenodd'
            />
            <path
                fill='#FF1A1A'
                d='M44.47 5.5h3.1v4.88h-3.1v11.28h-5.33V10.4H37V5.5h2.14V1.39h5.33V5.5Z'
            />
        </SvgElement>
    )
);
